import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_backer_center_update_feed_preview = _resolveComponent("backer-center-update-feed-preview")
  const _component_backer_center_section = _resolveComponent("backer-center-section")

  return (_openBlock(), _createBlock(_component_backer_center_section, {
    title: _ctx.Resources.BackerCenter.SectionUpdatesFeedHeader,
    "link-more": $options.linkMore,
    "label-more": _ctx.Resources.BackerCenter.ViewUpdateFeedLabel,
    "is-loading": _ctx.isProcessing,
    "is-empty": !$options.hasUpdates,
    "empty-title": _ctx.Resources.BackerCenter.UpdatesFeedEmptyStateHeader,
    "empty-description": _ctx.Resources.BackerCenter.UpdatesFeedEmptyStateParagraph,
    "data-qa": "backer-center:UpdatesFeedTabs"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.effectiveUpdates, (update) => {
        return (_openBlock(), _createBlock(_component_backer_center_update_feed_preview, _mergeProps({
          key: update.projectUpdateID
        }, { ref_for: true }, update), null, 16 /* FULL_PROPS */))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title", "link-more", "label-more", "is-loading", "is-empty", "empty-title", "empty-description"]))
}